import * as React from 'react';
import { useDrag } from 'react-dnd';
import { FieldItem, ItemTypes } from '../types';
import { DragTag } from './drag-tag';
import { getEmptyImage } from 'react-dnd-html5-backend';

interface DragPanelComponentProps {
  className: string;
  field: FieldItem;
  onSelect: (field: FieldItem) => void;
  onRemove?: (field: FieldItem) => void;
  isDragging?: any;
  isSelected?: boolean;
  added?: boolean;
  subTitle?: string;
}

export const dragPanelForItemType = (itemType: ItemTypes) => {
  const DragPanelComponent: React.FC<DragPanelComponentProps> = ({
    field, className, isSelected, onSelect, onRemove, subTitle
  }) => {

    const [{}, drag, preview] = useDrag(() => ({
      item: { field, subTitle },
      type: itemType,
      collect: (monitor) => {
        return {
          isDragging: monitor.isDragging()
        };
      },
      canDrag: () => !isSelected
    }));

    React.useEffect(() => {
      preview(getEmptyImage(), { captureDraggingState: true });
    }, []);

    const handleOnClick = () => {
      if (!!onSelect) {
        if (isSelected) {
          onRemove?.(field);
        } else {
          onSelect(field);
        }
      }
    };

    const title = field.allLevelDescription || field.description;

    return <li className={className}>
      <DragTag
        title={title}
        active={isSelected}
        added={field.added}
        onClick={handleOnClick}
        ref={(node) => {
          drag(node);
        }}
        subTitle={subTitle}
      />
    </li>;
  };

  return (DragPanelComponent);
};
